import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DropZone,
  Stack,
  FormLayout,
  TextField,
  Thumbnail,
  Checkbox,
  Toast,
  Button,
  Text,
  Loading,
  ChoiceList,
  Select,
  ButtonGroup,
  Icon,
  TextContainer,
  Card,
  Modal,
  Tooltip,
} from "@shopify/polaris";
import { useParams } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import Instruction from "./Instruction";
import {
  LanguageMinor,
  MobileVerticalDotsMajor,
  ColorsMajor,
} from "@shopify/polaris-icons";
import Select2 from "react-select";
import AsyncSelect from "react-select/async";
import showTools from "../Assets/Images/show-tools.svg";
import hideTools from "../Assets/Images/hide-tools.svg";
import LoadingScreen from "../Components/LoadingScreen";
import instructionImg from "../Assets/Images/instruction-help.svg";

const BannerSection = (props) => {
  const [isSaving, setIsSaving] = useState(false);
  let object = JSON.parse(props.object);
  const [data, setData] = useState([]);
  const { id } = useParams();
  const refId = useRef(null);
  const handleChange = (newChecked) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, active: newChecked };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTemplate = (newValue) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, template: newValue };
      }
      return obj;
    });
    setData(newState);
  };
  const [
    firstTimeLoadedCollectionsOptions,
    setFirstTimeLoadedCollectionsOptions,
  ] = useState([]);

  const loadOptionsCollections = (inputValue, callback) => {
    axios
      .get(`/shopify-collections?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: item.handle,
                id: item.id,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedCollectionsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: item.handle,
              id: item.id,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    object = JSON.parse(props.object);
    setData(
      props.languagesArray
        .concat([{ label: "English", value: "en" }])
        .map((element, index) => {
          return {
            language: element.value,
            title:
              object?.title && object?.title[element.value]
                ? object?.title[element.value]
                : "",
            subtitle:
              object?.subtitle && object?.subtitle[element.value]
                ? object?.subtitle[element.value]
                : "",

            instruction: object?.instructions ? object?.instructions : "",
            active: object?.details?.is_active ? true : false,
            collection: object?.title?.en ? object?.title?.en : "",
            collectionHandle: {
              label: object?.title?.en ? object?.title?.en : "",
              value:
                object?.details && object?.details?.collection_handle
                  ? object?.details?.collection_handle
                  : "",
              id:
                object?.details && object?.details?.collection_id
                  ? object?.details?.collection_id
                  : "",
            },

            template:
              object?.template_id !== null
                ? String(object?.template_id)
                : props.templates[0]?.id
                ? props.templates[0]?.id
                : "",
            image:
              object?.details?.image && object?.details?.image[element.value]
                ? object?.details?.image[element.value]
                : "",
            vimeoId:
              object?.details?.vimeo_id &&
              object?.details?.vimeo_id[element.value]
                ? object?.details?.vimeo_id[element.value]
                : "",
            youtubeId:
              object?.details?.youtube_id &&
              object?.details?.youtube_id[element.value]
                ? object?.details?.youtube_id[element.value]
                : "",
            link_mp4:
              object?.details?.link_mp4 &&
              object?.details?.link_mp4[element.value]
                ? object?.details?.link_mp4[element.value]
                : "",
            vimeo_id:
              object?.details?.vimeo_id &&
              object?.details?.vimeo_id[element.value]
                ? object?.details?.vimeo_id[element.value]
                : "",
            link_ogg:
              object?.details?.link_ogg &&
              object?.details?.link_ogg[element.value]
                ? object?.details?.link_ogg[element.value]
                : "",
            link_webm:
              object?.details?.link_webm &&
              object?.details?.link_webm[element.value]
                ? object?.details?.link_webm[element.value]
                : "",
            video_mp4: "",
            video_ogg: "",
            video_webm: "",
            image_mp4:
              object?.details?.file_mp4 &&
              object?.details?.file_mp4[element.value]
                ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                : "",
            image_ogg:
              object?.details?.file_ogg &&
              object?.details?.file_ogg[element.value]
                ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                : "",
            image_webm:
              object?.details?.file_webm &&
              object?.details?.file_webm[element.value]
                ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                : "",
          };
        })
    );
    setOptionsCollections();
  }, [props.object]);
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="There is no shopify domain to activate this section"
      onDismiss={toggleActive}
    />
  ) : null;
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((popoverActive) => !popoverActive),
    []
  );
  const [optionsCollections, setOptionsCollections] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState("");
  const handleChangeCollectionModal = () => {
    setActiveChangeCollection(false);
  };
  const [activeChangeCollection, setActiveChangeCollection] = useState(false);
  const handleChangeCollection = (newValue) => {
    console.log(newValue);
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, collectionHandle: newValue };
      }
      return obj;
    });
    setData(newState);
  };
  const handleSaveCollection = () => {
    setActiveChangeCollection(false);
  };
  const [translatedButtonClicked, setTranslatedButtonClicked] = useState(false);
  const handleTranslate = () => {
    setTranslatedButtonClicked(!translatedButtonClicked);
  };
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const handleSelectChangeLanguage = (value) => {
    setSelectedLanguage(value);
  };
  const [boolRichTextTools, setBoolRichTextTools] = useState(false);
  const handleChangeTitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeText = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, text: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTextTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, text: value };
      }
      return obj;
    });
    setData(newState);
  };

  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload actionHint={"Accepts pngs, jpegs, svgs and jsons"} />
  );
  const uploadedFile = file && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const [imageError, setImageError] = useState("");

  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "image");
    form_data.append("image[en]", file[file.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              fileImage: imageKey.current,
              image:
                validImageTypes.indexOf(file[file.length - 1].type) > 0
                  ? window.URL.createObjectURL(file[file.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [fileTranslated, setFileTranslated] = useState();
  const handleDropZoneDropTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileTranslated((fileTranslated) => acceptedFiles[0]),
    []
  );
  const fileUploadTranslated = !fileTranslated && (
    <DropZone.FileUpload actionHint={"Accepts pngs, jpegs, svgs and jsons"} />
  );
  const uploadedFileTranslated = fileTranslated && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileTranslated.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const sendImageTranslated = (fileTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "image");
    form_data.append(
      `image[${selectedLanguage}]`,
      fileTranslated[fileTranslated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              fileImage: imageKey.current,
              image:
                validImageTypes.indexOf(
                  fileTranslated[fileTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileTranslated[fileTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDeleteImage = (field, language) => {
    refId.current = field + ";" + language;
    console.log(field + ";" + language);
    setActiveDelete(true);
  };

  const handleYesDelete = () => {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("entity_type", "section");
    form_data.append("entity_id", props.sectionId);
    form_data.append("field", refId.current.split(";")[0]);
    form_data.append("language_code", refId.current.split(";")[1]);
    axios
      .post(`/remove/image`, form_data)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        const newState = data.map((obj) => {
          if (obj.language === refId.current.split(";")[1]) {
            if (refId.current.split(";")[0] === "image")
              return {
                ...obj,
                image: "",
              };
            else
              return {
                ...obj,
                mobileImage: "",
              };
          }
          return obj;
        });
        setData(newState);
      })
      .catch((err) => console.log(err));
  };

  const [fileMp4, setFileMp4] = useState();
  const handleDropZoneDropMp4 = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileMp4((fileMp4) => acceptedFiles[0]),
    []
  );

  const fileUploadMp4 = !fileMp4 && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFileMp4 = fileMp4 && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileMp4.name}{" "}
        <Text variant="bodySm" as="p">
          {fileMp4.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const imageKey = useRef("");
  const sendFileMp4 = (fileMp4) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append("video[en]", fileMp4[fileMp4.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              video_mp4: imageKey.current,
              image_mp4:
                validImageTypes.indexOf(fileMp4[fileMp4.length - 1].type) > 0
                  ? window.URL.createObjectURL(fileMp4[fileMp4.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileMp4Translated, setFileMp4Translated] = useState();
  const handleDropZoneDropMp4Translated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileMp4Translated((fileMp4Translated) => acceptedFiles[0]),
    []
  );

  const fileUploadMp4Translated = !fileMp4Translated && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFileMp4Translated = fileMp4Translated && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileMp4Translated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileMp4Translated.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendFileMp4Translated = (fileMp4Translated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append(
      `video[${selectedLanguage}]`,
      fileMp4Translated[fileMp4Translated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              video_mp4: imageKey.current,
              image_mp4:
                validImageTypes.indexOf(
                  fileMp4Translated[fileMp4Translated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileMp4Translated[fileMp4Translated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileOgg, setFileOgg] = useState();
  const handleDropZoneDropOgg = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileOgg((fileOgg) => acceptedFiles[0]),
    []
  );

  const fileUploadOgg = !fileOgg && (
    <DropZone.FileUpload actionHint={"Accepts ogg"} />
  );
  const uploadedFileOgg = fileOgg && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileOgg.name}{" "}
        <Text variant="bodySm" as="p">
          {fileOgg.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendFileOgg = (fileOgg) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append("video[en]", fileOgg[fileOgg.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              video_ogg: imageKey.current,
              image_ogg:
                validImageTypes.indexOf(fileOgg[fileOgg.length - 1].type) > 0
                  ? window.URL.createObjectURL(fileOgg[fileOgg.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileOggTranslated, setFileOggTranslated] = useState();
  const handleDropZoneDropOggTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileOggTranslated((fileOggTranslated) => acceptedFiles[0]),
    []
  );

  const fileUploadOggTranslated = !fileOggTranslated && (
    <DropZone.FileUpload actionHint={"Accepts ogg"} />
  );
  const uploadedFileOggTranslated = fileOggTranslated && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileOggTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileOggTranslated.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendFileOggTranslated = (fileOggTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append(
      `video[${selectedLanguage}]`,
      fileOggTranslated[fileOggTranslated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              video_ogg: imageKey.current,
              image_ogg:
                validImageTypes.indexOf(
                  fileOggTranslated[fileOggTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileOggTranslated[fileOggTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileWebm, setFileWebm] = useState();
  const handleDropZoneDropWebm = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileWebm((fileWebm) => acceptedFiles[0]),
    []
  );

  const fileUploadWebm = !fileWebm && (
    <DropZone.FileUpload actionHint={"Accepts webm"} />
  );
  const uploadedFileWebm = fileWebm && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileWebm.name}{" "}
        <Text variant="bodySm" as="p">
          {fileWebm.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendFileWebm = (fileWebm) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append("video[en]", fileWebm[fileWebm.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              video_webm: imageKey.current,
              image_webm:
                validImageTypes.indexOf(fileWebm[fileWebm.length - 1].type) > 0
                  ? window.URL.createObjectURL(fileWebm[fileWebm.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileWebmTranslated, setFileWebmTranslated] = useState();
  const handleDropZoneDropWebmTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileWebmTranslated((fileWebmTranslated) => acceptedFiles[0]),
    []
  );

  const fileUploadWebmTranslated = !fileWebmTranslated && (
    <DropZone.FileUpload actionHint={"Accepts webm"} />
  );
  const uploadedFileWebmTranslated = fileWebmTranslated && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileWebmTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileWebmTranslated.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendFileWebmTranslated = (fileWebmTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "video");
    form_data.append(
      `video[${selectedLanguage}]`,
      fileWebmTranslated[fileWebmTranslated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              video_webm: imageKey.current,
              image_webm:
                validImageTypes.indexOf(
                  fileWebmTranslated[fileWebmTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileWebmTranslated[fileWebmTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };
  const handleChangeLinkMp4 = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, link_mp4: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkMp4Translated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, link_mp4: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkOgg = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, link_ogg: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkOggTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, link_ogg: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkWebm = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, link_webm: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkWebmTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, link_webm: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeVimeoId = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, vimeo_id: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeVimeoIdranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, vimeo_id: value };
      }
      return obj;
    });
    setData(newState);
  };
  return (
    <FormLayout>
      {/* <Instruction
        text={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").instruction
        }
        pageId={id}
        sectionId={props.sectionId}
        handleRefreshSections={props.handleRefreshSections}
      /> */}
      <div style={{ float: "right" }}>
        <ButtonGroup>
          {/* <Button
            onClick={() => {
              setBoolRichTextTools(!boolRichTextTools);
            }}
            plain
          >
            <img src={boolRichTextTools ? showTools : hideTools} width={22} />
          </Button> */}
          <Button
            plain
            onClick={handleTranslate}
            icon={!translatedButtonClicked ? LanguageMinor : ""}
          >
            {translatedButtonClicked ? "Edit English" : "Translate"}
          </Button>
          {/* <Button
            plain
            onClick={() => props.handleCustomizeStyles()}
            icon={ColorsMajor}
          >
            Customize Styles
          </Button> */}
        </ButtonGroup>
      </div>

      <table>
        <tbody>
          <tr>
            <th>
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
            </th>
            <th>
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
            </th>
            {translatedButtonClicked && (
              <th>
                <Select
                  // helpText="Please select a language before you fill data"
                  options={props.languagesArray}
                  onChange={handleSelectChangeLanguage}
                  value={selectedLanguage}
                  placeholder="Please select a language"
                />
              </th>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Title
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").title
                }
                onChange={handleChangeTitle}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).title
                  }
                  onChange={handleChangeTitleTranslated}
                />
              </td>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Subtitle
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").subtitle
                }
                onChange={handleChangeSubtitle}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).subtitle
                  }
                  onChange={handleChangeSubtitleTranslated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Image
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image
                        ? findArrayElementByLanguage(data, "en").image
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".png,.jpeg,.jpg,.svg,.json"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDrop}
                    onDropAccepted={sendImage}
                  >
                    {uploadedFile}
                    {fileUpload}
                  </DropZone>
                </div>
              </div>
              <div className="mt-2">
                <Button
                  outline
                  size="slim"
                  destructive
                  onClick={() => handleDeleteImage("image", "en")}
                >
                  Delete Image
                </Button>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage).image
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    {/* <DropZone
                      accept=".png,.jpeg,.jpg,.svg,.json"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropTranslated}
                      onDropAccepted={sendImageTranslated}
                    >
                      {uploadedFileTranslated}
                      {fileUploadTranslated}
                    </DropZone> */}

                    <DropZone
                      accept=".png,.jpeg,.jpg,.svg,.json"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropTranslated}
                      onDropAccepted={sendImageTranslated}
                    >
                      {uploadedFileTranslated}
                      {fileUploadTranslated}
                    </DropZone>
                  </div>
                </div>
                <div className="mt-2">
                  <Button
                    outline
                    size="slim"
                    destructive
                    onClick={() => handleDeleteImage("image", selectedLanguage)}
                  >
                    Delete Image
                  </Button>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Link Mp4
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").link_mp4
                }
                onChange={handleChangeLinkMp4}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).link_mp4
                  }
                  onChange={handleChangeLinkMp4Translated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Video Mp4
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_mp4
                        ? findArrayElementByLanguage(data, "en").image_mp4
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".mp4"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropMp4}
                    onDropAccepted={sendFileMp4}
                  >
                    {uploadedFileMp4}
                    {fileUploadMp4}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_mp4
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_mp4
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".mp4"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropMp4Translated}
                      onDropAccepted={sendFileMp4Translated}
                    >
                      {uploadedFileMp4Translated}
                      {fileUploadMp4Translated}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Link Ogg
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").link_ogg
                }
                onChange={handleChangeLinkOgg}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).link_ogg
                  }
                  onChange={handleChangeLinkOggTranslated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Video Ogg
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_ogg
                        ? findArrayElementByLanguage(data, "en").image_ogg
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".ogg"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropOgg}
                    onDropAccepted={sendFileOgg}
                  >
                    {uploadedFileOgg}
                    {fileUploadOgg}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_ogg
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_ogg
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".ogg"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropOggTranslated}
                      onDropAccepted={sendFileOggTranslated}
                    >
                      {uploadedFileOggTranslated}
                      {fileUploadOggTranslated}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Link Webm
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").link_webm
                }
                onChange={handleChangeLinkWebm}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).link_webm
                  }
                  onChange={handleChangeLinkWebmTranslated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Video Webm
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_webm
                        ? findArrayElementByLanguage(data, "en").image_webm
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".webm"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropWebm}
                    onDropAccepted={sendFileWebm}
                  >
                    {uploadedFileWebm}
                    {fileUploadWebm}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_webm
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_webm
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".webm"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropWebmTranslated}
                      onDropAccepted={sendFileWebmTranslated}
                    >
                      {uploadedFileWebmTranslated}
                      {fileUploadWebmTranslated}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Vimeo Id
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").vimeo_id
                }
                onChange={handleChangeVimeoId}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).vimeo_id
                  }
                  onChange={handleChangeVimeoIdranslated}
                />
              </td>
            )}
          </tr>

          {/* <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Text
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").text
                }
                onChange={handleChangeText}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).text
                  }
                  onChange={handleChangeTextTranslated}
                />
              </td>
            )}
          </tr> */}
        </tbody>
      </table>
      {/* <Text>
        Collection:{" "}
        {findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").collection}
      </Text> */}
      <Button primary onClick={() => setActiveChangeCollection(true)}>
        Change Collection
      </Button>
      <Text>Template: </Text>
      <div className="boxTemplates">
        {props.templates?.length ? (
          props.templates.map((item, index) => {
            return (
              <div
                style={{ marginRight: "1rem" }}
                key={item.id}
                onClick={() => handleChangeTemplate(item.id)}
                className={`divTemplate ${
                  findArrayElementByLanguage(data, "en")
                    ? String(
                        findArrayElementByLanguage(data, "en").template
                      ) === String(item.id) && "borderTemplate"
                    : ""
                }`}
              >
                {item.text && (
                  <div className="templateInstruction">
                    <Tooltip content={item.text}>
                      <img
                        src={instructionImg}
                        width={17}
                        className="templateInstruction"
                      />
                    </Tooltip>
                  </div>
                )}

                <div className="buttonTemplate">
                  {item.image && <img src={item.image} width={30}></img>}
                  <div style={{ marginTop: "0.2rem" }}>
                    <Text color="subdued">{item.description}</Text>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <Text color="subdued">No templates added for this section type</Text>
        )}
      </div>
      <Checkbox
        label="Is Active"
        checked={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").active
        }
        onChange={handleChange}
      />
      <FormLayout.Group>
        <div style={{ float: "right" }}>
          <Button primary onClick={handleSave} loading={props.isSaving}>
            Save
          </Button>
        </div>
      </FormLayout.Group>

      <Modal
        open={activeChangeCollection}
        onClose={handleChangeCollectionModal}
        title="Change Collection"
        primaryAction={{
          content: "Done",
          onAction: handleSaveCollection,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleChangeCollectionModal,
          },
        ]}
      >
        <Card sectioned>
          <FormLayout>
            <AsyncSelect
              cacheOptions
              defaultOptions={firstTimeLoadedCollectionsOptions}
              loadOptions={loadOptionsCollections}
              onChange={handleChangeCollection}
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              value={
                findArrayElementByLanguage(data, "en") &&
                findArrayElementByLanguage(data, "en").collectionHandle
              }
            />

            {/* <asyncselect
              cacheoptions
              loadOptionsCollections={loadOptionsCollections}
              options={props.collectionsArray.map((item, index) => {
                return {
                  label: item.label,
                  value: item.handle,
                };
              })}
              oninputchange={handleChangeInput}
              onChange={handleChangeCollection}
              value={
                findArrayElementByLanguage(data, "en") &&
                findArrayElementByLanguage(data, "en").collectionHandle
              }
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              textFieldProps={{
                label: "Collection",
              }}
            /> */}
            {/* <Select2
              options={props.collectionsArray.map((item, index) => {
                return {
                  label: item.label,
                  value: item.handle,
                };
              })}
              onChange={handleChangeCollection}
              value={
                findArrayElementByLanguage(data, "en") &&
                findArrayElementByLanguage(data, "en").collectionHandle
              }
             
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              textFieldProps={{
                label: "Collection",
              }}
            /> */}
          </FormLayout>
        </Card>
      </Modal>
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Image"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>Are you sure you want to delete this image?</p>
          </TextContainer>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </FormLayout>
  );
  function handleSave() {
    props.handleSavingState();
    const form_data = new FormData();
    findArrayElementByLanguage(data, "en") &&
      (findArrayElementByLanguage(data, "en").template === "none"
        ? form_data.append(`template_id`, "")
        : form_data.append(
            `template_id`,
            findArrayElementByLanguage(data, "en").template
          ));
    form_data.append("is_active", data[data.length - 1].active ? 1 : 0);
    props.selectedChannels && props.selectedChannels.length
      ? props.selectedChannels.forEach((selected, index) =>
          form_data.append(`channels[${index}]`, selected)
        )
      : form_data.append(`channels`, []);

    findArrayElementByLanguage(data, "en").collectionHandle &&
      form_data.append(
        "collection_handle",
        findArrayElementByLanguage(data, "en").collectionHandle.value
      );
    findArrayElementByLanguage(data, "en").collectionHandle &&
      form_data.append(
        "collection_id",
        findArrayElementByLanguage(data, "en").collectionHandle.id
      );

    data.forEach((selected, index) =>
      form_data.append(`subtitle[${selected.language}]`, selected.subtitle)
    );
    data.forEach((selected, index) =>
      form_data.append(`title[${selected.language}]`, selected.title)
    );
    data.forEach(
      (selected, index) =>
        selected.fileImage &&
        form_data.append(`image[${selected.language}]`, selected.fileImage)
    );
    data.forEach(
      (selected, index) =>
        selected.video_mp4 &&
        form_data.append(`file_mp4[${selected.language}]`, selected.video_mp4)
    );
    data.forEach(
      (selected, index) =>
        selected.video_ogg &&
        form_data.append(`file_ogg[${selected.language}]`, selected.video_ogg)
    );
    data.forEach(
      (selected, index) =>
        selected.video_webm &&
        form_data.append(`file_webm[${selected.language}]`, selected.video_webm)
    );
    data.forEach((selected, index) =>
      form_data.append(`link_mp4[${selected.language}]`, selected.link_mp4)
    );
    data.forEach((selected, index) =>
      form_data.append(`link_ogg[${selected.language}]`, selected.link_ogg)
    );
    data.forEach((selected, index) =>
      form_data.append(`link_webm[${selected.language}]`, selected.link_webm)
    );
    data.forEach((selected, index) =>
      form_data.append(`vimeo_id[${selected.language}]`, selected.vimeo_id)
    );
    form_data.append("_method", "PATCH");
    axios
      .post(`/pages/${id}/sections/${props.sectionId}`, form_data)
      .then((res) => {
        props.handleSaveAndRefresh();
      })
      .catch((err) => {
        toggleActive();
        props.handleResetSavingState();
      });
  }
  function findArrayElementByLanguage(array, language) {
    return array.find((element, index) => {
      return element.language === language;
    });
  }
};
export default BannerSection;
